import { useReducedMotion } from 'framer-motion'

import { useUiStore } from '@/store/useUiStore'

export function useMotionPreference() {
  const motionPreference = useUiStore((state) => state.motionPreference)
  const reducedBySystem = useReducedMotion()

  return (
    motionPreference === 'reduce' || (motionPreference === 'system' && reducedBySystem === true)
  )
}
